export enum SHOPIFY_DATA_SOURCE {
  SHOPIFY_APP = 'shopify_app',
  DATA_SOURCE = 'data_source',
  ONBOARDING_INTENT = 'onboarding_intent',
  NONE = 'none',
}
